import React from "react";
import styled, { useTheme } from "styled-components";
import {
  DateRangePicker as MuiDateRangePicker,
  LocalizationProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@material-ui/pickers/adapter/date-fns";
import { he } from "date-fns/locale";
import { useTranslation } from "react-i18next";
import { TextField } from "@mui/material";
import dateImg from "../../asserts/img/calender_input.svg";

const Label = styled.label(({ theme }) => ({
  textAlign: "right",
  fontSize: 14,
  color: theme.color.text,
  display: "flex",
  alignItems: "center",
  marginInlineEnd: "1em",
}));

const TillDateLabel = styled.label(({ theme }) => ({
  color: theme.color.text,
  fontWeight: 600,
  fontSize: 17,
  textAlign: "start",
  padding: "0.7em",
  height: "100%",
  lineHeight: "17px"
}));

const StyledMuiDateRangePicker = styled(MuiDateRangePicker)(() => ({}));

const StyledInputDate = styled(TextField)(({ theme, isRtl }) => ({
  border: `1px solid ${theme.color.darkGray} !important`,
  borderRadius: 8,
  height: 42,
  width: 180,

  "&&": {
    ".MuiInputBase-input": {
      color: theme.color.text,
      fontSize: 15,
      textAlign: "start",
      direction: isRtl ? "rtl" : "ltr",
    },

    ".MuiOutlinedInput-root": {
      boxSizing: "border-box",
      boxShadow: "none",
      border: 0,
      lineHeight: 1,
    },
    ".MuiOutlinedInput-notchedOutline": {
      border: 0,
      lineHeight: 1,
    },
  },
}));

// Pass `value` ([from, to]) to control it from the page, so what's shown always matches the
// filter that's applied; without it the picker keeps its own state as before
const DateRangePicker = ({ value, handleDateChange }) => {
  const { t, i18n } = useTranslation("common");
  const isRtl = i18n.dir() === "rtl";
  const [selectedDate, setSelectedDate] = React.useState([null, null]);
  const theme = useTheme();
  const shownDate = value !== undefined ? value || [null, null] : selectedDate;

  return (
    <form>
      <div style={{ marginInlineStart: 20, display: "flex" }}>
        <Label>{t("filter_by_date")}</Label>
        <div
          style={{
            display: "flex",
            borderRadius: 8,
            maxHeight: 42,
          }}>
          <LocalizationProvider dateAdapter={DateFnsUtils} locale={he}>
            <StyledMuiDateRangePicker
              sx={{
                "& .MuiPickersDateRangePickerInput-root": {
                  alignItems: "center",
                },
              }}
              startText=""
              endText=""
              mask="__/__/__"
              inputFormat="dd/MM/yy"
              value={shownDate}
              onChange={(date) => {
                setSelectedDate(date);
                handleDateChange(date);
              }}
              renderInput={(startProps, endProps) => (
                <>
                  <StyledInputDate
                    isRtl={isRtl}
                    theme={theme}
                    {...startProps}
                    helperText={null}
                    variant="outlined"
                    size="small"
                    InputProps={{
                      placeholder: null,
                      startAdornment: (
                        <img
                          alt="date"
                          src={dateImg}
                          style={{
                            marginLeft: !isRtl ? 10 : 5,
                            marginRight: isRtl ? 10 : 5,
                          }}
                        />
                      ),
                    }}
                  />
                  <TillDateLabel theme={theme}>{t("till")} </TillDateLabel>
                  <StyledInputDate
                    isRtl={isRtl}
                    theme={theme}
                    {...endProps}
                    helperText={null}
                    variant="outlined"
                    size="small"
                    InputProps={{
                      placeholder: "",
                      startAdornment: (
                        <img
                          alt="date"
                          src={dateImg}
                          style={{
                            marginLeft: !isRtl ? 10 : 5,
                            marginRight: isRtl ? 10 : 5,
                          }}
                        />
                      ),
                    }}
                  />
                </>
              )}
            />
          </LocalizationProvider>
        </div>
      </div>
    </form>
  );
};
export default DateRangePicker;
